module.exports = __webpack_public_path__ + "static/media/train11.e360b3dc.jpg";